import React, {AnchorHTMLAttributes, ReactNode} from "react";
import {Label14} from "../typography/Typography";
import styles from "./TextLink.module.css";

interface TextLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children: ReactNode;
    href: string;
    icon?: ReactNode;
}

export default function TextLink({children, icon, ...anchorProps}: TextLinkProps) {
    return (
        <a {...anchorProps} className={styles.link}>
            {
                icon &&
                <span className={styles.icon}>{icon}</span>
           }

            <Label14 variant="medium" color="black">
                {children}
            </Label14>
        </a>
    );
}
